// import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
// import { useNavigate } from 'react-router-dom';
// import Header from './Header';
// import { useEffect, useState } from 'react';
// import axios from "axios";

// function Homepage() {
//   const navigate = useNavigate()
//  const [servers, setServers] = useState([]);

//   useEffect(() => {
//     axios
//       .get("http://localhost:3003/vpn-servers")
//       .then((res) => {
//         setServers(res.data.data); // API mathi badho data
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   }, []);

//    useEffect(() => {
//     fetchServers();
//   }, []);

//   const fetchServers = async () => {
//     const res = await axios.get("http://localhost:3003/vpn-servers");
//     setServers(res.data.data);
//   };

//   const handleToggle = async (serverId, currentIsFree) => {
//     const newIsFree = currentIsFree === 1 ? 0 : 1;

//     // 1️⃣ UI update immediately
//     setServers((prev) =>
//       prev.map((item) =>
//         item.serverId === serverId
//           ? { ...item, isfree: newIsFree }
//           : item
//       )
//     );

//     // 2️⃣ DB update
//     try {
//       await axios.put(
//         `http://localhost:3003/vpn-servers/${serverId}`,
//         { isfree: newIsFree }
//       );
//     } catch (err) {
//       console.error("Update failed", err);
//       fetchServers(); // rollback if error
//     }
//   };
//   return (

//     <>
//     <Header/>
//     <Container>
//       <Row className='mt-5'>
//         <Col>
//        <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
//       {servers.map((item, index) => (
//         <Card key={index} style={{ width: "18rem" }}>
//           <Card.Body>
//            <h6> Server Name : {item.serverName}</h6>

//             <h6>  Country : {item.country} </h6>

//            <Form.Check
//               type="switch"
//               id={`switch-${item.serverId}`}
//               label={item.isfree === 1 ? "ON" : "OFF"}
//               checked={item.isfree === 1}
//               onChange={() =>
//                 handleToggle(item.serverId, item.isfree)
//               }
//             />

//           </Card.Body>
//         </Card>
//       ))}
//     </div>
//         </Col>
//       </Row>
//     </Container>

//     </>
//   )
// }

// export default Homepage

import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

function Homepage() {
  const navigate = useNavigate();
  const [servers, setServers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const BASE_URL = "https://vpnbackend.banksstatements.com";
  // const BASE_URL = "http://localhost:3003";

  // ✅ Only ONE useEffect
  useEffect(() => {
    fetchServers();
  }, []);

  const fetchServers = async () => {
    const res = await axios.get(`${BASE_URL}/vpn-servers`);

    const normalized = res.data.data.map((item) => ({
      ...item,
      isfree: Number(item.isFree), // 👈 exact fix
      Status: item.Status,
    }));

    setServers(normalized);
  };

  const handleToggle = async (id, currentIsFree) => {
    const newIsFree = currentIsFree === 1 ? 0 : 1;

    // 🔥 1. UI instantly update
    setServers((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, isfree: newIsFree } : item,
      ),
    );

    // 🔥 2. Database update
    try {
      await axios.put(`${BASE_URL}/vpn-servers/${id}`, {
        isfree: newIsFree,
      });
    } catch (err) {
      console.error("Update failed", err);
      fetchServers(); // rollback if error
    }
  };

  const handleStatusToggle = async (id, currentStatus) => {
    const newStatus = currentStatus === "on" ? "off" : "on";

    // 🔥 1. Instant UI update
    setServers((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, Status: newStatus } : item,
      ),
    );

    // 🔥 2. DB update
    try {
      await axios.put(`${BASE_URL}/vpn-servers/${id}`, {
        Status: newStatus,
      });
    } catch (err) {
      console.error("Status update failed", err);
      fetchServers(); // rollback
    }
  };

  const filteredServers = servers.filter(
    (item) =>
      item.serverName.toLowerCase().includes(search.toLowerCase()) ||
      item.country.toLowerCase().includes(search.toLowerCase()),
  );

  const syncVpnData = async () => {
    try {
      setLoading(true);

      const res = await axios.post(`${BASE_URL}/sync-vpn-data`);

      toast.success(`✅ ${res.data.message}`);
    } catch (err) {
      toast.error("❌ VPN data sync failed");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
  try {
    if (!window.confirm("Are you sure you want to delete this VPN server?")) {
      return;
    }

    const res = await axios.delete(`${BASE_URL}/delete-server/${id}`);

    toast.success(res.data.message || "Deleted successfully");

    fetchServers(); // refresh list
  } catch (error) {
    toast.error(
      error.response?.data?.message || "❌ Delete failed"
    );
  }
};


  return (
    <>
      <Header />
      <Container>
        <Row className="mt-5">
          <Col md={6}>
            <Form.Control
              type="text"
              placeholder="Search by server name or country..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Col>
          <Col md={6} className="text-end">
            <Button variant="primary" onClick={syncVpnData} disabled={loading}>
              {loading ? "Syncing..." : "Reset Data"}
            </Button>
          </Col>
        </Row>
        {/* <Row className="mt-5 mb-5">
          <Col>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
              {servers.map((item) => (
                <Card key={item.serverId} style={{ width: "18rem" }}>
                  <Card.Body>
                    <h6>Server Name : {item.serverName}</h6>
                    <h6>Country : {item.country}</h6>
                    <div className="d-flex justify-content-between">
                      <div>
                        <img
                          className="mt-2"
                          src={item.flag_url}
                          alt=""
                          height={"30px"}
                        />
                      </div>
                      <div>
                        <Form.Check
                          className="mt-3"
                          type="switch"
                          checked={Number(item.isfree) === 1}
                          label={
                            <span className="ms-2">
                              {Number(item.isfree) === 1 ? "ON" : "OFF"}
                            </span>
                          }
                          onChange={() =>
                            handleToggle(item.serverId, Number(item.isfree))
                          }
                        />
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              ))}
            </div>
          </Col>
        </Row> */}
        <Row className="mt-5 mb-5">
          <Col>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "25px" }}>
              {filteredServers.map((item) => (
                <Card key={item.id} style={{ width: "23rem" }}>
                  <Card.Body>
                    <div className="d-flex justify-content-between align-items-center">
                    <h6>Server Name : {item.serverName}</h6>
                     <Button variant="danger" onClick={() => handleDelete(item.id)}><i class="fa-regular fa-trash-can"></i></Button>
                    </div>
                    <h6 className="mt-3">Country : {item.country}</h6>
                    <h6 className="mt-4">Alias : {item.alias.split("|")[0].trim()}</h6>

                    <div className="d-flex justify-content-between mt-3">
                      <img
                        className="mt-2"
                        src={item.flag_url}
                        alt=""
                        height="30"
                      />

                      <Form.Check
                        className=""
                        type="switch"
                        checked={item.isfree === 1}
                        label={
                          <span className="ms-2">
                            {item.isfree === 1 ? "Pro" : "Free"}
                          </span>
                        }
                        onChange={() => handleToggle(item.id, item.isfree)}
                      />
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <h6 className="mb-0">Status :</h6>
                      <Form.Check
                        type="switch"
                        checked={item.Status === "on"}
                        label={
                          <span className="ms-2">
                            {item.Status === "on" ? "On" : "Off"}
                          </span>
                        }
                        onChange={() =>
                          handleStatusToggle(item.id, item.Status)
                        }
                      />
                    </div>
                  </Card.Body>
                </Card>
              ))}

              {filteredServers.length === 0 && (
                <p className="text-center mt-4">No servers found 🚫</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default Homepage;
